<template>
  <b-modal title="Add dashboard section" class="modal-light" v-model="showModal" @ok="submit">
    <b-row>
      <b-col sm='4'>Section name:</b-col>
      <b-col sm='8'>
        <b-form-input type='text' v-model='name'></b-form-input>
      </b-col>
    </b-row>
  </b-modal>
</template>

<script>

export default {
  name: 'SectionModal',
  components: {
  },

  created () {
    this.$eventBus.$on('addSection', this.addSection)
  },

  beforeDestroy(){
    this.$eventBus.$off('addSection')
  },

  data () {
    return {
      name: null,
      showModal: false
    }
  },

  methods: {
    addSection () {
      this.showModal = true
    },

    submit () {
      var params = {
        section: { name: this.name }
      }
      this.$http.post('/dashboards/' + this.$route.params.id + '/sections', params)
        .then(function(response){
          this.$parent.loadSections(response.data.id)
          this.name = ''
        }.bind(this))
    },

  }

}
</script>
